<div class="terms-page">
    <div class="terms-container">
        <h1>Terms and Conditions</h1>


        <ul>
            <li>SmartFunder and Absa have partnered to offer credit solutions that can help you pay for your studies.
            </li>
            <li>Absa is a registered bank that extends credit to eligible applicants. SmartFunder hosts the Absa
                Education Application Platform that enables you to apply for credit to fund your studies at your chosen
                educational institution.</li>
            <li>To deliver these services, Absa and SmartFunder may exchange your personal information with one another
                and, where necessary, with third parties such as educational institutions and service providers.</li>
            <li>This information sharing enables Absa to assess and provide credit to qualifying clients and allows
                SmartFunder to operate the platform and communicate with you through email, SMS, WhatsApp, or other
                appropriate channels.</li>
        </ul>
    </div>
</div>